import { motion } from "framer-motion";

const TESTIMONIALS = [
  { quote: "Adtrax kept me loaded through a slow February. My dispatcher fought for every extra $200 on the rate — I felt it in my settlement.", name: "Marcus R.", role: "Owner-Op · 2-truck fleet, Dry Van" },
  { quote: "I stopped fighting brokers over detention. Adtrax handles the calls, sends the paperwork, and it just shows up on my invoice.", name: "Jessi T.", role: "Owner-Op · Reefer" },
  { quote: "Onboarded on a Monday, first load Tuesday morning. Same dispatcher every load — she knows my truck like her own.", name: "Devon O.", role: "Owner-Op · Flatbed" },
];

export default function Testimonials() {
  return (
    <section className="bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.8 }} className="font-mono-label text-xs text-[#FF4500]">CHAPTER 06 / WHAT DRIVERS SAY</motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-bold text-4xl md:text-6xl mt-4 leading-[1] max-w-3xl">
          Words from the<br/>drivers who <span className="italic">stayed.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-black/10 border border-black/10">
          {TESTIMONIALS.map((t, i) => (
            <motion.div key={i}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.8, delay: 0.1 + i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="bg-white p-10 flex flex-col group hover:bg-[#F8F9FA] transition-colors duration-500" data-testid={`testimonial-${i}`}>
              <span className="font-display text-6xl text-[#FF4500]/40 leading-none">&ldquo;</span>
              <p className="font-display text-2xl leading-tight mt-2 flex-1">{t.quote}</p>
              <div className="pt-10 mt-10 border-t border-black/10">
                <p className="font-medium">{t.name}</p>
                <p className="font-mono-label text-[10px] text-black/50 mt-1">{t.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
